import React from "react";
import classNames from "classnames";

import "./styles.styl";

/**
 * creates a dummy wrapper div
 * WARNING this is not a component
 * @param name
 * @param className
 * @param rest
 * @returns {*}
 */
function wrapper(name, { className, ...rest }) {
  return <div className={classNames(name, className)} {...rest} />;
}

// Container Component
export function Container(props) {
  return wrapper("container", props);
}

// Grid Component
export function Grid(props) {
  return wrapper("grid", props);
}

// Cell Component
export function Cell(props) {
  // remove these keys
  let { size, sizeS, sizeM, sizeL, ...rest } = props;

  let sizeProps = ["size", "sizeS", "sizeM", "sizeL"];
  let className = "cell";

  sizeProps.forEach((prop) => {
    const fraction = props[prop];

    // the fraction for this prop was not defined
    if (!fraction) return;

    const numCols = fraction === "auto" ? "auto" : fraction * 12;

    let cellClassName = `cell-${numCols}`;

    if (prop !== "size") {
      const key = prop.slice(-1).toLowerCase();

      cellClassName += `@${key}`;
    }

    className = classNames(className, cellClassName);
  });

  return wrapper(className, rest);
}
